import { Fragment } from "react";
import About from "../About";
import BecomeProducer from "../BecomeProducer";
import Careers from "../Careers";
import Claims from "../Claims";
import Contact from "../Contact";
import Coverages from "../Coverages";
import GetQuote from "../GetQuote";
import Markets from "../Markets";
import NavBar from "../NavBar";
import OfficeOfCompliance from "../OfficeOfCompliance";
//import PreferedVendors from "../PreferedVendors";
import Resources from "../Resources";

const Main = () => {
    return (
        <Fragment>
            <NavBar />
            <Coverages />
            <Markets />
            <About />
            <GetQuote />
            <BecomeProducer />
            <Contact />
            <Claims />
            <OfficeOfCompliance />
            <Careers />
            {/* <PreferedVendors />*/}
            <Resources />
        </Fragment>
    )
}
export default Main;